import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ConsultationAttachmentFile, ConsultationSectionDataMap, ConsultationSectionKey,
} from '@features/web/patients/domain/models/clinical-history.model';
import {
  IClientConsultationSectionsGateway,
} from '@features/web/patients/domain/repositories/client-consultation-sections.gateway';
import { CLIENT_PRESCRIPTIONS_REPOSITORY } from '../../domain/repositories/client-prescriptions.repository';
import { CLIENTS_REPOSITORY } from '../../domain/repositories/clients.repository';

@Injectable()
export class ClientConsultationSectionsGateway implements IClientConsultationSectionsGateway {
  private readonly repository = inject(CLIENTS_REPOSITORY);
  private readonly prescriptionsRepository = inject(CLIENT_PRESCRIPTIONS_REPOSITORY);

  public getConsultationSection<K extends ConsultationSectionKey>(
    clientId: string, patientId: string, consultationId: string, section: K,
  ): Observable<ConsultationSectionDataMap[K]> {
    // `ClientConsultationSectionDataMap` mirrors the patients map field for field (that is the whole
    // point of both existing), but TypeScript cannot prove two indexed accesses on two distinct
    // declarations equivalent while `K` is still a type parameter -- so the bridge is asserted here,
    // once, instead of the eleven section components each taking a union of two identical types.
    return this.repository.getConsultationSection(clientId, patientId, consultationId, section) as
      Observable<ConsultationSectionDataMap[K]>;
  }

  public downloadPrescriptionPdf(
    clientId: string, patientId: string, prescriptionExternalId: string, locale: string,
  ): Observable<Blob> {
    return this.prescriptionsRepository.downloadPdf(clientId, patientId, prescriptionExternalId, locale);
  }

  public downloadConsultationAttachment(
    clientId: string, patientId: string, consultationId: string, noteId: string, uploadId: string,
  ): Observable<Blob> {
    return this.repository.downloadConsultationAttachment(clientId, patientId, consultationId, noteId, uploadId);
  }

  public getConsultationAnalysisReferralAttachments(
    clientId: string, patientId: string, consultationId: string, referralId: string,
  ): Observable<readonly ConsultationAttachmentFile[]> {
    return this.repository.getConsultationAnalysisReferralAttachments(clientId, patientId, consultationId, referralId);
  }
}
